<template>
  <CommonPage>
    <div class="login-content">
      <h3 class="box-title">维盟应用市场</h3>
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item prop="username">
          <el-input prefix-icon="el-icon-user" placeholder="账号" clearable maxLength="18"
                    v-model.trim="form.username" @keyup.enter.native="accountLogin"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input prefix-icon="el-icon-lock" placeholder="密码" clearable show-password maxLength="14"
                    v-model.trim="form.password" @keyup.enter.native="accountLogin"></el-input>
        </el-form-item>
        <el-form-item prop="vcode">
          <el-col :span="15">
            <el-input placeholder="验证码" clearable maxLength="6" prefix-icon="el-icon-edit-outline"
                      v-model.trim="form.vcode" @keyup.enter.native="accountLogin"></el-input>
          </el-col>
          <el-col :span="8" :offset="1">
            <div class="image-code-box" @click="getVerifycode" title="点击更换">
              <el-image :src="verifycodeSrc"/>
            </div>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" class="login-btn" @click="accountLogin">确定</el-button>
    </div>
  </CommonPage>
</template>

<script>
  import {inputEmpty} from "@utils/validate"
  import CommonPage from "@view/components/CommonPage"
  export default {
    name: "index",
    components: {CommonPage},
    data() {
      return {
        verifycodeSrc: "",
        form: {
          username: process.env.NODE_ENV === "production" ? "" : "liuai",
          password: process.env.NODE_ENV === "production" ? "" : "wayos028",
          vcode: "",
          captcha_id: "",
        },
        rules: {
          username: [inputEmpty("账号")],
          password: [inputEmpty("密码")],
          vcode: [inputEmpty("验证码")]
        }
      }
    },
    methods: {
      // 获取图片验证码
      async getVerifycode() {
        this.form.vcode = "";
        let res = await this.$Http.getCaptcha();
        if (res?.data) {
          this.verifycodeSrc = `data:image/png;base64,${res.data.verifycode}`;
          this.form.captcha_id = res.data.captcha_id;
        }
      },
      // 账号登陆
      accountLogin() {
        this.$refs['form'].validate(async isOk => {
          if (isOk) {
            let nv = {...this.form};
            nv.password = encodeURIComponent(this.form.password);
            let res = await this.$Http.login(nv);
            if (res?.data) {
              this.loginSuccess(res.data);
            } else {
              this.getVerifycode();
            }
          }
        })
      },
      loginSuccess(data) {
        this.$store.commit("setLoginInfo", {
          uid: data.uid,
          token: data.utoken,
          nickName: data.name,
          isAdmin: +data.is_super,
        });
        this.msgSuccess("登录成功");
        this.$router.replace("/index").catch(() => {});
      },
      checkLogin() {
        let obj = this.$route.query || {};
        if (obj.utoken) {
          this.loginSuccess(obj);
        } else {
          this.getVerifycode();
        }
      },
    },
    created() {
      this.checkLogin();
    }
  }
</script>

<style lang="scss" scoped>
  .login-content {
    .box-title {
      font-size: 30px;
      text-align: center;
      line-height: 46px;
      color: #000;
      font-weight: normal;
      margin-bottom: 40px;
    }
    .image-code-box {
      box-sizing: border-box;
      height: 40px;
      cursor: pointer;
      border: 1px solid $input-border-color;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .login-btn {
      margin: 15px 0 20px;
      width: 100%;
      border-radius: 20px!important;
    }
  }
</style>
